module.exports = __webpack_public_path__ + "static/media/delete_forever_black5f37a192.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/delete_forever_black.svg
// module id = 229
// module chunks = 0